































































import {
  Component,
  Vue
} from "vue-property-decorator";
@Component
export default class PopUpButton extends Vue {
  private isVisible = false;
  showPopUp() {
    this.isVisible = true;
  }
}
